<template>
  <div id="terms" class="header-padding bg-light-grey">
    <header class="page-header border-bottom ff ff-center horizontal-padding section-padding">
      <h1 v-if="pageContent" style="margin-bottom: 0;">{{ pageContent.name }}</h1>
    </header>
    
    <section v-if="terms" role="content" class="horizontal-padding section-padding max-width">
      <div class="content-block" v-html="terms"></div>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "terms",
  data() {
    return {
      pageContent: null,
      loading: false
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    terms() {
      var terms = '';
      
      if(this.pageContent) {
        terms = this.pageContent.content.rows[0].blocks[0].content;
      }
      
      return terms;
    },
    pageName() {
      var pageName = '';
      
      if(this.pageContent) {
        pageName = this.pageContent.name;
      }
      
      return pageName;
    },
    meta() {
      var meta = {
        title: this.pageName,
        url: "https://www.csbplab.com.au/terms-and-conditions",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
    // Check if we have pre-loaded the data server-side
    if(window.__INITIAL_STATE__) {
      var init_state = JSON.parse(window.__INITIAL_STATE__);
      
      if('terms' in init_state.data) {
        this.pageContent = init_state.data.terms;
      }
      
    }
    
    // If not, start loading the data client-side
    if(!this.pageContent) {
      this.loadContent();
    }
    
  },
  mounted() {
    
  },
  methods: {
     async loadContent() {
      // Start loading
      this.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+'terms-and-conditions').then((response) => {
        this.pageContent = response.data.page;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the content for this page. Please reload page to try again.");
      });
      
      // Finish loading
      this.loading = false;
      
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>